export default {
  CREATE_Label: () => `/label`,
  GET_Label: () => `/label`,
  GET_Label_ALL: () => `/label/all`,
  
  
  
  GET_Label_By_Id: (id) => `/label/${id}`,
  Update_Label_By_Id: (id) => `/label/${id}`,
  DELETE_Label_By_Id:(id) => `/label/${id}`,
  GET_ALL_INTERNAL_NOTES: () => `/internalNote`,
};
